import React from 'react';
import {useSelector} from 'react-redux';

import AppLoader from '../../components/Loader/AppLoader';
import {selectGlobalLoader} from '../../state/selectors/global';

const LoaderGlobal = () => {
    const loaders = useSelector(selectGlobalLoader);

    if (loaders.length <= 0) return null;

    const activeLoader = loaders[loaders.length - 1];

    return <AppLoader {...activeLoader} />;
};

export default LoaderGlobal;
